import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function HeroSection() {
  return <section className="relative pt-12 pb-6 px-6 md:pt-16 md:pb-8 max-w-4xl mx-auto text-center" data-id="element-248">
      {/* Subtle background glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-2xl h-64 bg-[#4A5D3A] opacity-5 blur-[100px] rounded-full pointer-events-none" data-id="element-249"></div>

      <FadeIn data-id="element-250">
        <p className="text-sm md:text-base italic text-[#9B4F2B] mb-6 font-medium tracking-wide" data-id="element-251">
          Cuando por fin te acuestas… tu cuerpo está agotado pero tu mente sigue
          acelerada.
        </p>
      </FadeIn>

      <FadeIn delay={0.2} data-id="element-252">
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-[#2D2A26] leading-tight mb-8" data-id="element-253">
          No es solo la planta. Es el método botánico correcto para calmar tu
          sistema nervioso.
        </h1>
      </FadeIn>

      <FadeIn delay={0.4} data-id="element-254">
        <div className="max-w-3xl mx-auto" data-id="element-255">
          <p className="text-lg md:text-xl text-[#2D2A26] mb-4 leading-relaxed" data-id="element-256">
            Descubre el protocolo botánico de 15 minutos que te enseña:
              </p>
             <p className="text-lg md:text-xl text-[#2D2A26] mb-4 leading-relaxed" data-id="element-257">
                🌿 Las 3 plantas exactas que ayudan a calmar el sistema nervioso
          </p>
             <p className="text-lg md:text-xl text-[#2D2A26] mb-4 leading-relaxed" data-id="element-258">
            🌡️ La temperatura correcta de preparación
          </p>
            <p className="text-lg md:text-xl text-[#2D2A26] mb-4 leading-relaxed" data-id="element-259">
            ⏱️ El orden preciso para liberar sus compuestos naturales
          </p>
          <p className="text-lg md:text-xl text-[#2D2A26] mb-4 leading-relaxed" data-id="element-260">
            Porque cuando las plantas se preparan correctamente, tu sistema nervioso recibe la señal que necesita:
          </p>
          <h2 className="text-2xl md:text-3xl font-serif italic text-[#4A5D3A] font-semibold mb-8" data-id="element-261">
            "Ya estamos a salvo. Ya puedes soltar."
          </h2>

          <img src="https://cdn.magicpatterns.com/uploads/o8sNLG3chtmHx3UkA9gpkv/MOCKUP.png" alt="Rescate Herbáceo S.O.S. — Guía digital completa" className="w-full max-w-2xl mx-auto rounded-2xl shadow-xl mb-8" data-id="element-262" />

          <a href="https://pay.hotmart.com/Y104754180A?checkoutMode=10" target="_blank" rel="noopener noreferrer" className="inline-block w-full max-w-lg mx-auto text-center bg-[#4A5D3A] text-[#FAF6F0] font-bold py-5 px-8 rounded-xl shadow-lg hover:bg-[#3a4a2e] transition-colors text-lg md:text-xl animate-pulse-subtle" data-id="element-263">
            QUIERO EL MÉTODO DE RESCATE BOTÁNICO → $6.39 USD
          </a>
          <p className="text-sm text-[#2D2A26]/60 font-medium mt-3" data-id="element-264">
            🔒 Pago Seguro ⚡ Acceso en 2 min
          </p>
        </div>
      </FadeIn>
    </section>;
}